module.exports = __webpack_public_path__ + "img/ícone-ver-senha.f6248912.svg";